import { __rest } from "tslib";
import * as React from 'react';
import { useMemo } from 'react';
import Money from '../../../../../../../Money';
import css from './ElementsPriceDetails.css';
import { useTranslation } from 'react-i18next';
const isTaxRetention = (element) => {
    return element.hasOwnProperty('taxCode');
};
const ElementsPriceDetails = props => {
    const { t } = useTranslation('Exchange');
    const detailsByTypes = useMemo(() => {
        var _a;
        const byTypes = new Map();
        (_a = props.elements.elements) === null || _a === void 0 ? void 0 : _a.forEach(element => {
            const elementKey = `${element.type}_${element.taxCode || ''}`;
            const selectedElement = byTypes.get(elementKey);
            if (selectedElement) {
                const updateElement = Object.assign(Object.assign({}, selectedElement), { money: Object.assign(Object.assign({}, selectedElement.money), { amount: selectedElement.money.amount + element.money.amount }) });
                byTypes.set(elementKey, updateElement);
            }
            else {
                const { passengerId } = element, otherProperties = __rest(element, ["passengerId"]);
                byTypes.set(elementKey, otherProperties);
            }
        });
        return byTypes;
    }, [props.elements]);
    const details = Array.from(detailsByTypes);
    return (React.createElement("div", { className: props.className }, details.map(([type, element], idx) => {
        return (React.createElement("div", { className: css.item, key: `${idx}${element.type}`, "data-item-type": element.type },
            React.createElement("div", null, isTaxRetention(element) ? `${t('Fee')} ${t(element.taxCode)}` : t(element.type)),
            React.createElement(Money, { money: {
                    amount: Math.abs(element.money.amount),
                    currency: element.money.currency
                } })));
    })));
};
export default ElementsPriceDetails;
